/**

 * Medical context for QuickHook (guest first contact).

 * Multi-select; "none" is exclusive.

 */



export const MEDICAL_OPTIONS = [

  { key: 'none', labelKey: 'medical.options.none' },

  { key: 'current_condition', labelKey: 'medical.options.current_condition' },

  { key: 'family_history', labelKey: 'medical.options.family_history' },

  { key: 'medical_restriction', labelKey: 'medical.options.medical_restriction' },

  { key: 'recovering', labelKey: 'medical.options.recovering' },

];



/**

 * @param {string[]} flags

 * @returns {string[]}

 */

export function normalizeMedicalFlags(flags) {

  const list = Array.isArray(flags) ? flags.map(String).filter(Boolean) : [];

  if (list.includes('none') || list.length === 0) return ['none'];

  return [...new Set(list.filter((k) => k !== 'none'))];

}



/**

 * Toggle one medical option with exclusive "none".

 * @param {string[]} current

 * @param {string} key

 * @returns {string[]}

 */

export function toggleMedicalFlag(current, key) {

  const set = new Set(normalizeMedicalFlags(current).filter((k) => k !== 'none'));

  if (key === 'none') return ['none'];

  if (set.has(key)) set.delete(key);

  else set.add(key);

  return set.size === 0 ? ['none'] : [...set];

}



/**

 * @param {string[]} flags

 * @returns {boolean}

 */

export function hasMedicalCaution(flags) {

  const normalized = normalizeMedicalFlags(flags);

  return normalized.some((k) =>

    k === 'current_condition' || k === 'medical_restriction' || k === 'recovering'

  );

}



/**

 * Soft caution: family history alone does not force protective training,

 * but still informs version/tools.

 * @param {string[]} flags

 */

export function hasAnyMedicalSignal(flags) {

  const normalized = normalizeMedicalFlags(flags);

  return !normalized.includes('none') || normalized.length > 1;

}


